import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";

const API_URL = import.meta.env.VITE_API_URL || "https://api.endoac.ro";

export default function useFinancialReportData() {
  const { token } = useAuth();
  const [state, setState] = useState({
    loading: true,
    error: null,
    monthOrder: [],
    monthlyData: {},
  });

  useEffect(() => {
    let cancelled = false;

    const fetchReport = async () => {
      if (!token) {
        setState({ loading: false, error: null, monthOrder: [], monthlyData: {} });
        return;
      }

      setState((prev) => ({ ...prev, loading: true, error: null }));

      try {
        const res = await fetch(`${API_URL}/api/reports/financial`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();

        if (!res.ok) {
          throw new Error(data?.message || "Nu am putut încărca raportul financiar.");
        }

        if (!cancelled) {
          setState({
            loading: false,
            error: null,
            monthOrder: data?.data?.monthOrder || [],
            monthlyData: data?.data?.monthlyData || {},
          });
        }
      } catch (error) {
        if (!cancelled) {
          setState({
            loading: false,
            error: error?.message || "Eroare la încărcarea raportului financiar.",
            monthOrder: [],
            monthlyData: {},
          });
        }
      }
    };

    fetchReport();

    return () => {
      cancelled = true;
    };
  }, [token]);

  return state;
}
